export default "__VITE_ASSET__C$p4jj9L__"